import React from "react";

import { useIntl } from "react-intl";

import { APP_NAME } from "Constants/documentationUrls";
import { Link } from "ds/Button";

import { getLeftPanelLinks } from "../auth/pages/registration/utils";

import * as S from "./CustomLeftPane.styles";
import VideoPlayer from "./video/VideoPlayer";

const CustomLeftPane = () => {
  const intl = useIntl();
  const tsl = getLeftPanelLinks();

  const isVideoDefined = tsl["links.auth.video_src"] in intl.messages;
  const isHeroTextDefined = "custom.auth.hero_text" in intl.messages;
  const isDescriptionDefined = "custom.auth.description" in intl.messages;
  const isCtaTextDefined = "custom.auth.cta_text" in intl.messages;
  const isFooterTextDefined = "custom.auth.footer_text" in intl.messages;
  const isTrialTextDefined =
    tsl["auth.left_panel.deploy_for_free.title"] in intl.messages;

  const isFirstBulletDefined =
    "auth.left_panel.deploy_for_free.description.first.bullet" in intl.messages;
  const isSecondBulletDefined =
    "auth.left_panel.deploy_for_free.description.second.bullet" in
    intl.messages;
  const isThirdBulletDefined =
    "auth.left_panel.deploy_for_free.description.third.bullet" in intl.messages;

  const isVideoTitleDefined =
    tsl["auth.left_panel.video.title"] in intl.messages;

  return (
    <>
      {isVideoDefined ? (
        <>
          <S.VideoLeftLayout>
            <S.VideoTitleContainer>
              {isVideoTitleDefined && (
                <S.VideoTitle>
                  {intl.formatMessage({
                    id: tsl["auth.left_panel.video.title"]
                  })}
                </S.VideoTitle>
              )}
            </S.VideoTitleContainer>

            <VideoPlayer
              src={intl.formatMessage({ id: tsl["links.auth.video_src"] })}
              title={intl.formatMessage({ id: "auth.video_title" })}
            />

            {isTrialTextDefined && (
              <S.VideoTextWrapper>
                <S.VideoBodyTitle size="small" weight="semiBold">
                  {intl.formatMessage({
                    id: tsl["auth.left_panel.deploy_for_free.title"]
                  })}
                </S.VideoBodyTitle>
                <S.VideoBodyText size="extraSmall" weight="regular">
                  {intl.formatMessage({
                    id: "auth.left_panel.deploy_for_free.description"
                  })}
                </S.VideoBodyText>
              </S.VideoTextWrapper>
            )}

            <S.BulletsTextWrapper>
              {isFirstBulletDefined && (
                <S.ListWrapper>
                  <S.BulletTick />

                  <S.BulletBodyText size="extraSmall" weight="regular">
                    {intl.formatMessage({
                      id: "auth.left_panel.deploy_for_free.description.first.bullet"
                    })}
                  </S.BulletBodyText>
                </S.ListWrapper>
              )}

              {isSecondBulletDefined && (
                <S.ListWrapper>
                  <S.BulletTick />

                  <S.BulletBodyText size="extraSmall" weight="regular">
                    {intl.formatMessage({
                      id: "auth.left_panel.deploy_for_free.description.second.bullet"
                    })}
                  </S.BulletBodyText>
                </S.ListWrapper>
              )}

              {isThirdBulletDefined && (
                <S.ListWrapper>
                  <S.BulletTick />

                  <S.BulletBodyText size="extraSmall" weight="regular">
                    {intl.formatMessage({
                      id: "auth.left_panel.deploy_for_free.description.third.bullet"
                    })}
                  </S.BulletBodyText>
                </S.ListWrapper>
              )}
            </S.BulletsTextWrapper>
          </S.VideoLeftLayout>
        </>
      ) : (
        <S.LeftLayout>
          <>
            <S.MainImageContainer />
            <S.TextTitleContainer>
              {isHeroTextDefined && (
                <S.Title>
                  {intl.formatMessage({
                    id: "custom.auth.hero_text"
                  })}
                </S.Title>
              )}
            </S.TextTitleContainer>
            <S.TextDescriptionContainer>
              {isDescriptionDefined && (
                <S.Description>
                  {intl.formatMessage({
                    id: "custom.auth.description"
                  })}
                </S.Description>
              )}
            </S.TextDescriptionContainer>
            <S.ButtonWrapper>
              {isCtaTextDefined && (
                <Link
                  analyticId="custom.auth.cta_text"
                  variant="primary"
                  href={intl.formatMessage({
                    id: "custom.auth.cta_href"
                  })}
                >
                  {intl.formatMessage({
                    id: "custom.auth.cta_text"
                  })}
                </Link>
              )}
            </S.ButtonWrapper>
            <S.FooterContainer>
              {isFooterTextDefined && (
                <S.FooterText>
                  {intl.formatMessage(
                    { id: "custom.auth.footer_text" },
                    { app_name: APP_NAME }
                  )}
                </S.FooterText>
              )}
            </S.FooterContainer>
          </>{" "}
        </S.LeftLayout>
      )}
    </>
  );
};

export default CustomLeftPane;
